import React from "react";
import { Link } from "react-router-dom"
import "./Navbar.css"

const Navbar = () => {
    return(
        <div>
            <nav className="navbar">
                <Link className="logo" to="/"><img className='img-v3career' src={require('../../static/images/v3careers.png')} alt="V3" /></Link>
                <ul className="nav-links">
                    <input type="checkbox" id="checkbox_toggle" />
                    <label htmlFor="checkbox_toggle" className="hamburger">&#9776;</label>
                    <div className="menu">
                        <li><a href="/">Home</a></li>
                        <li><a href="/jobs">All Jobs</a></li>
                    </div>
                </ul>
            </nav>
        </div>
    );
};

export default Navbar;